"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentArea = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var HydrationContext_1 = require("./HydrationContext");
var useHydrationContentId = function () {
    var _a = react_1.default.useContext(HydrationContext_1.HydrationContext), hostId = _a.hostId, counter = _a.contentAreaIndex;
    var hydrationId = react_1.default.useMemo(function () {
        var id = "".concat(hostId, "-").concat(counter.current);
        counter.current++;
        return id;
    }, []);
    return hydrationId;
};
var ContentAreaComponent = function (props) {
    var _a, _b, _c;
    var hydrationId = useHydrationContentId();
    var attributes = (0, lodash_1.omit)(props, "children");
    var content = (_c = (_a = props.children) !== null && _a !== void 0 ? _a : (_b = document.querySelector("[data-hydration-content-id=\"".concat(hydrationId, "\"]"))) === null || _b === void 0 ? void 0 : _b.innerHTML) !== null && _c !== void 0 ? _c : "";
    return (react_1.default.createElement("div", __assign({}, attributes, { "data-hydration-content-id": hydrationId, dangerouslySetInnerHTML: {
            __html: content,
        } })));
};
var ContentArea = react_1.default.memo(ContentAreaComponent);
exports.ContentArea = ContentArea;
